<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">站内信</div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="bj-rows">
            <div :class="['item-radio',{ active: index == statusSelect}]"
              v-for="(item, index) in statusList"
              :key="index"
              @click="statusSelectChange(index)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px;">
        <div class="item">
          <div class="name" style="margin-right: 10px">类型：</div>
            <Select
              class="bj-select-h45 bj-bg-color-26262A "
              v-model="mailTypeSelect"
              style="width: 220px"
              clearable
            >
              <Option
                v-for="item in mailSiteTypeList"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
        </div>
        <div class="item" style="margin-left: 40px">
          <div class="name" style="margin: 0 20px">关键词：</div>
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="keyword"
            placeholder="请输入搜索的关键词"
            style="width: 200px"
            clearable
          />
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin: 0 20px 0 60px;"
            @click="pageChange(1)"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="reset"
            style="margin-right: 20px"
            >重置</Button
          >
        </div>
      </div>
      
    </div>
    <div class="bj-table-data">
      <div class="bj-result-row">
          <div class="total">搜索结果<span class="count">（{{ total }}）</span></div>  
          <div class="opration">
            <span v-if='isRead === 0' @click="setAsRead">设为已读</span>
            <span v-if='isRead === 0' @click="allSetAaRead">全部设为已读</span>
            <span @click="delectEvent">删除</span>
          </div>   
      </div>
      
       <Table
            class="bj-2F3033-table"
            :loading="loading"
            ref="pushDomianTable"
            :columns="columns"
            :data="list"
            :disabled-hover="true"
            @on-select="onSelectEvent"
            @on-select-cancel="onSelectCancelEvent"
            @on-select-all="onSelectAllEvent"
            @on-select-all-cancel="onSelectAllCancelEvent"
            stripe
       ></Table>
      <div class="page-tool">
        <Page
              :total="total"
              :current="page"
              :page-size="pageSize"
              :page-size-opts="pageSizeOpts"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              show-elevator
              show-sizer
              show-total
         />
      </div>
    </div>
   
  </div>
</template>
<script>
import { pullAllWith, isEqual } from "lodash";
import { mailSiteList, mailSiteType,mailSiteRead  } from "api/user.js";
import { mapActions } from "vuex";
export default {
  name: "mail",
  data() {
    return {
      loading: false,
      isRead:0,
      statusList: [
        {
          name: "未读短信",
          value: 0,
        },
        {
          name: "已读短信",
          value: 1,
        }
      ],
      mailSiteTypeList: [],

      // 表单数据
      statusSelect: 0,
      keyword: "",
      mailTypeSelect: null,

      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          width: 100,
          title: "状态",
          key: "readFlag",
          align: "center",
          render: (h, params) => {
            let title = params.row.readFlag === 0 ? '未读' :'已读' ;
            return h("span", title);
          },
        },
        {
          width: 150,
          title: "类型",
          key: "target",
          align: "center",
        },
        {
          minWidth: 200,
          title: "标题",
          key: "content",
          align: "left",
          render: (h, params) => {
            return h(
              "p",
              {
                style: {
                    padding:'10px 0',
                },
              },
              params.row.content
            );
          },
        },
        {
          width: 200,
          title: "时间",
          key: "createdTime",
          align: "left",
        }
      ],
      selectAll: false,
      // 保存选中的数据
      selectList: [],

      // 分页设置
      total: 0,
      pageSizeOpts: [50, 100, 200],
      pageSize: 50,
      page: 1,
      list: [],
    }
  },
  created() {
    this.getMailSiteType()
    this.pageChange(1)
  },
  methods: {
     ...mapActions(["ACT_USER_INFO"]),
    // 获取站内信类型
    async getMailSiteType() {
      let {code,data} = await mailSiteType();
      if(code === 200){
        this.mailSiteTypeList = data
      }
    },
    // 交易类型改变
    statusSelectChange(index) {
      this.statusSelect = index
      this.isRead=this.statusList[this.statusSelect].value
      this.pageChange(1)
    },
  
    // 切换pageSize
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageChange(1)
    },
    // 切换页码
    pageChange(page) {
      this.page = page
      this.getMailSiteList()
    },
    // 重置
    reset() {
      this.keyword = ""
      this.mailTypeSelect = null
      this.page = 1
      this.getMailSiteList()
    },
    // 获取列表
    async getMailSiteList() {
      this.loading = true;
      let params = {
        kw: this.keyword,
        siteType: this.mailTypeSelect,
        isRead:this.statusList[this.statusSelect].value,
        limit: this.pageSize,
        page: this.page,
      };
      let res = await mailSiteList(params);
      if (res.code == 200) {
         this.list = res.data.list;
         this.total = res.data.total; 
      }
      this.loading = false;
    },

    // 设为已读
    async setAsRead(){
     if(this.selectList.length <= 0){
        this.$Message.warning("请选择数据");
        return;
      }
      let msgIds = this.selectList.map(item => item.id)
      let params = {
        msgIds: msgIds,
        isReadAll: 0
      }
      const {code} = await mailSiteRead(params);
      if(code === 200){
        this.$Message.success("设置成功");
        this.page = 1;
        this.getMailSiteList();
        this.ACT_USER_INFO();
      }
    },
    // 全部设为已读
    allSetAaRead(){
     this.$Modal.confirm({
        title: "全部设为已读",
        content: "<p>确定全部设为已读吗？</p>",
        onOk: async () => {
         this.$refs.pushDomianTable.selectAll(true);
         let msgIds = this.selectList.map(item => item.id)
          let params = {
            msgIds: msgIds,
            isReadAll: 1
          }
          const {code} = await mailSiteRead(params);
          if(code === 200){
            this.$Message.success("设置成功");
            this.page = 1;
            this.getMailSiteList();
            this.ACT_USER_INFO();
          }
        },
      })
    },
    // 删除
    delectEvent(){
      if(this.selectList.length <= 0){
        this.$Message.warning("请选择数据");
        return;
      }
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除吗？</p>",
        onOk: async () => {
          let msgIds = this.selectList.map(item => item.id)
          const res = await mialSiteDel({msgIds});
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("删除成功！");
            this.page = 1;
            this.getMailSiteList();
            this.ACT_USER_INFO();
          }
        },
      })
    },
    // checkbox全选的数据
    onSelectAllEvent(selection) {
       this.selectList = selection
    },
    // checkbox取消全选的数据
    onSelectAllCancelEvent() {
      this.selectList = []
    },
    // checkbox单个选中数据
    onSelectEvent(selection, row) {
      this.selectList.push(row) 
    },
    // checkbox单个取消数据
    onSelectCancelEvent(selection, row) {
      this.selectList = pullAllWith(this.selectList, [row], isEqual)
    }
  },
};
</script>
<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          flex-shrink: 0;
          color: #fff;
        }
      }
    }
  }
  .bj-result-row{
    display: flex;
    align-items: center;
    .opration{
      margin: 0 0 20px 20px;
      span{
        margin-right: 15px;
        color: #F85A36;
        cursor: pointer;
        &:hover{
          opacity: 0.85;
        }
      }
    }
  }
  .item-radio{
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
    margin-right: 40px;
    border: 1px solid #fff;
    min-width: 100px;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    transition: all .3s;
  }
  .item-radio.active {
    color: #fff;
    background-color: #F85A36;
  }
</style>

